__turbopack_context__.v({
  "animationArea": "WcVhza_animationArea",
  "causeText": "WcVhza_causeText",
  "divider": "WcVhza_divider",
  "simple": "WcVhza_simple",
  "slideTrack": "WcVhza_slideTrack",
});
